import { useLanguagePreference } from '@/hooks/useLanguagePreferenceContext/useLanguagePreference';

import { LanguageContext } from './LanguageContext';

export const LanguagePreferenceProvider = ({ children }) => {
  const [language, setLanguage] = useLanguagePreference();

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
